import { AccessToken } from '@azure/core-http';
import { useAuth } from '@workos-inc/authkit-react';
import { useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAuthActions } from './auth-actions.hook';

export function useAccessToken() {
  const { getAccessToken } = useAuth();
  const { signIn } = useAuthActions();

  const getTypedAccessToken = useCallback(async () => {
    try {
      const token = await getAccessToken();
      const decoded = jwtDecode(token);
      const exp = decoded.exp;
      const expiresOnTimestamp = exp ? exp * 1000 : new Date().getTime() + 3600 * 1000;
      const accessToken: AccessToken = {
        token,
        expiresOnTimestamp
      };
      return accessToken;
    } catch {
      signIn();
      return null;
    }
  }, [getAccessToken, signIn]);

  return {
    getAccessToken: getTypedAccessToken
  };
}
